import React from 'react';

const IframeModal = ({ show, onClose, url }) => {
  if (!show) return null;

  return (
    <div
      className="modal-backdrop"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1050,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        className="modal-content"
        style={{
          position: 'relative',
          width: "90%",
          height: "90%",
          backgroundColor: "#fff",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 10,
            right: 15,
            fontSize: '1.5rem',
            background: 'none',
            border: 'none',
            color: '#333',
            cursor: 'pointer'
          }}
        >
          &times;
        </button>

        <iframe
          src={url}
          title="Waiver Sample"
          style={{ width: '100%', height: '100%', border: 'none' }}
        />
      </div>
    </div>
  );
};

export default IframeModal;
